import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    sideBar: true,
    offCanva: false,
    contentLoading: false,
    auth: true,
};

const componentSlice = createSlice({
    name: "component",
    initialState,
    reducers: {
        authChange: (state, { payload }) => {
            state.auth = payload;
        },
        sideBarChange: (state, { payload }) => {
            state.sideBar = payload;
        },
        offCanvaChange: (state, { payload }) => {
            state.offCanva = payload;
        },
        contentLoadingChange: (state, { payload }) => {
            state.contentLoading = payload;
        },
    },
});

export const { authChange, sideBarChange, offCanvaChange, contentLoadingChange } = componentSlice.actions;
export default componentSlice.reducer;
